import clsx from 'clsx'

import { useBooleanState } from '@/shared/lib/hooks/useBooleanState'

import { CloseIcon } from '../../assets/close-icon'
import { OpenIcon } from '../../assets/open-icon'

import cl from './style.module.scss'

export const SummaryLatter = () => {
	const { active, disable, enable } = useBooleanState()
	return (
		<li className={clsx(cl.item, { [cl.item_active]: active })}>
			<p className={clsx(cl.label, { [cl.label_mb]: active })}>Раньше.</p>
			<h4 className={clsx(cl.title, { [cl.title_hidden]: active })}>
				Крупнейший партнёр Apple по&nbsp;сервисному обслуживанию в&nbsp;России.
			</h4>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				9&nbsp;лет iPort был крупнейшим официальным партнёром Apple в&nbsp;сервисном обслуживании (Apple Premium Service
				Provider), при этом имея самый высокий уровень качества как ремонтных работ, так и&nbsp;клиентского сервиса
				каждый год подтверждая этот статус.
			</p>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				По&nbsp;всем направлениям мы&nbsp;плотно работали с&nbsp;Apple&nbsp;&mdash; получали запчасти по&nbsp;прямым
				поставкам, сотрудники обучались по&nbsp;определённым стандартам, а&nbsp;вся работа регулировалась
				их&nbsp;регламентами.
			</p>
			<button className={clsx(cl.button, { [cl.button_hidden]: active })} onClick={enable}>
				<OpenIcon />
			</button>

			<button className={clsx(cl.button, { [cl.button_hidden]: !active })} onClick={disable}>
				<CloseIcon />
			</button>
		</li>
	)
}
